import { SET_ACTIVE_MODAL, SET_IS_LOADING } from "v2_actions/ui";

const initialState = {
  active_modal: "",
  modal_params: {},
  isLoading: false,
};

export default function ui(state = initialState, action) {
  switch (action.type) {
    case SET_ACTIVE_MODAL:
      return Object.assign({}, state, {
        active_modal: action.active_modal,
        modal_params: action.modal_params,
        isLoading: state.isLoading,
      });
    case SET_IS_LOADING:
      return Object.assign({}, state, {
        active_modal: state.active_modal,
        modal_params: state.modal_params,
        isLoading: action.isLoading,
      });
    default:
      return state;
  }
}
